import * as React from "react";

import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { TRADE_POSITION_SIDE_BADGE_CLASS } from "@/components/trade-position-side-badge";

/** Glacial green / red / orange gradient badges inside shadcn data tables. */
export type TradeLogGradientBadgeTone = "positive" | "negative" | "warning";

export function TradeLogGradientBadge({
  tone,
  children,
  className,
}: {
  tone: TradeLogGradientBadgeTone;
  children: React.ReactNode;
  className?: string;
}): React.ReactElement {
  if (tone === "positive") {
    return (
      <Badge data-trade-log-type-badge="buy" className={cn(TRADE_POSITION_SIDE_BADGE_CLASS, className)}>
        {children}
      </Badge>
    );
  }

  if (tone === "negative") {
    return (
      <Badge data-trade-log-type-badge="sell" className={cn(TRADE_POSITION_SIDE_BADGE_CLASS, className)}>
        {children}
      </Badge>
    );
  }

  return (
    <Badge
      data-trade-log-gradient-tone="warning"
      className={cn(TRADE_POSITION_SIDE_BADGE_CLASS, className)}
    >
      {children}
    </Badge>
  );
}
